import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Translate } from 'react-redux-i18n';
import { Table } from './components';
import OptionAlertTable from './components/OptionAlertTable';
import 'assets/css/alerts.css';

const Alerts = () => {
    const [tab, setTab] = useState('stocks');

    return (
        <div className="alerts-page">
            <div className="alerts-header">
                <div>
                    <h1 className="alerts-title">
                        <Translate value="alerts" />
                    </h1>
                    <p className="alerts-subtitle">
                        <Translate
                            value={tab === 'stocks' ? 'alerts_subtitle_stocks' : 'alerts_subtitle_options'}
                        />
                    </p>
                </div>
            </div>

            <div className="alerts-tabs" role="tablist">
                <button
                    type="button"
                    role="tab"
                    aria-selected={tab === 'stocks'}
                    className={`alerts-tab${tab === 'stocks' ? ' is-active' : ''}`}
                    onClick={() => setTab('stocks')}
                >
                    <Translate value="alerts_tab_stocks" />
                </button>
                <button
                    type="button"
                    role="tab"
                    aria-selected={tab === 'options'}
                    className={`alerts-tab${tab === 'options' ? ' is-active' : ''}`}
                    onClick={() => setTab('options')}
                >
                    <Translate value="alerts_tab_options" />
                </button>
            </div>

            <div className="alerts-card">
                {tab === 'stocks' ? <Table /> : <OptionAlertTable />}
            </div>
        </div>
    );
};

Alerts.propTypes = {
    history: PropTypes.object,
};

export default Alerts;
